module.exports = __webpack_public_path__ + "img/dead-grey-trunk-02.288d1234.png";